import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
  InputAdornment,
  FormControl,
  Divider,
  MenuItem,
  Grid,
  CircularProgress,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { register } from "../store/auth";
import { fetchPays, resetPaysState } from "../store/pays";
import art from '../assets/art.jpg'

const SignUpModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { registerError } = useSelector((state) => state.auth || {});
  const { items: pays, status, error, retryCount } = useSelector((state) => state.pays);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  // Fetch pays data when component mounts or modal opens
  useEffect(() => {
    if (open && (status === 'idle' || (status === 'failed' && retryCount < 3))) {
      console.log('Fetching pays data...');
      dispatch(fetchPays());
    }
  }, [dispatch, open, status, retryCount]);

  // Reset state when modal opens
  useEffect(() => {
    if (open) {
      dispatch(resetPaysState());
    }
  }, [open, dispatch]);

  // Log pays data when it changes
  useEffect(() => {
    if (pays && pays.length > 0) {
      console.log('Pays data updated:', pays);
    }
  }, [pays]);

  const [showPassword, setShowPassword] = useState(false);
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [adresse, setAdresse] = useState("");
  const [password, setPassword] = useState("");

  const handleClose = () => {
    setPrenom("");
    setNom("");
    setSelectedCountry("");
    setEmail("");
    setPhoneNumber("");
    setAdresse("");
    setPassword("");
    setShowPassword(false);
    setIsDropdownOpen(false);
    onClose();
  };

  const handleCountryChange = (event) => {
    console.log('Country selected:', event.target.value);
    setSelectedCountry(event.target.value);
  };

  const handleRetry = () => {
    console.log('Retrying pays fetch...');
    dispatch(fetchPays());
  };

  const handleRegister = () => {
    let missingFields = 0;

    if (!prenom) missingFields++;
    if (!nom) missingFields++;
    if (!email) missingFields++;
    if (!selectedCountry) missingFields++;
    // if (!phoneNumber) missingFields++;
    if (!adresse) missingFields++;
    if (!password) missingFields++;

    if (missingFields > 1) {
      toast.error("Tous les champs sont requis.", { theme: "dark" });
      return;
    }

    if (!prenom) {
      toast.error("Champ prénom est obligatoire.", { theme: "dark" });
      return;
    }
    if (!nom) {
      toast.error("Champ nom est obligatoire.", { theme: "dark" });
      return;
    }
    if (!email) {
      toast.error("Champ email est obligatoire.", { theme: "dark" });
      return;
    }
    if (!selectedCountry) {
      toast.error("Champ pays est obligatoire.", { theme: "dark" });
      return;
    }
    // if (!phoneNumber) {
    //   toast.error("Champ numéro de téléphone est obligatoire.", { theme: "dark" });
    //   return;
    // }
    if (!adresse) {
      toast.error("Champ adresse est obligatoire.", { theme: "dark" });
      return;
    }
    if (!password) {
      toast.error("Champ mot de passe est obligatoire.", { theme: "dark" });
      return;
    }

    const body = {
      prenom: prenom,
      nom: nom,
      email: email,
      paysId: selectedCountry,
      numeroTelephone: phoneNumber,
      adress: adresse,
      password: password,
    };


    dispatch(register(body)).then((response) => {
      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Inscription réussie !", { theme: "dark" });
        setMessage("Inscription réussie !");
        setMessageType("success");
        handleClose();
      } else {
        toast.error(response.error.message, { theme: "dark" });
        setMessage(response.error.message);
        setMessageType("error");
      }
    });
    
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "#333",
            color: "#A68E5D",
            borderRadius: 2,
            maxWidth: "500px",
            width: "100%",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
            textAlign: "center",
          },
          "& .MuiBackdrop-root": {
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "#A68E5D",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            paddingBottom: 0,
            fontSize: "1.5rem",
            textAlign: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 10, right: 10 }}
          >
            <CloseIcon sx={{ color: "#A68E5D" }} />
          </IconButton>
          <img
            src={art}
            alt="Icon"
            style={{ width: "50px", marginBottom: "10px" }}
          />
          Bienvenue sur notre site

        </DialogTitle>
        <Divider
          sx={{
            mt: 2,
            mb: 2,
            backgroundColor: "white",
            height: "1px",
            width: "100%",
          }}
        />
        <DialogContent>
          <FormControl fullWidth variant="outlined" margin="normal">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Prénom"
                  variant="outlined"
                  required
                  fullWidth
                  value={prenom}
                  onChange={(e) => setPrenom(e.target.value)}
                  InputLabelProps={{
                    style: {
                      color: "#A68E5D",
                    },
                  }}
                  InputProps={{
                    style: {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      borderColor: "#A68E5D",
                      borderRadius: "5px",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&:hover fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#A68E5D",
                      },
                    },
                    "& .MuiInputLabel-outlined.Mui-focused": {
                      color: "#A68E5D",
                    },
                    "& input:-webkit-autofill": {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      boxShadow: "0 0 0 1000px #444 inset",
                      transition: "background-color 5000s ease-in-out 0s",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Nom"
                  variant="outlined"
                  required
                  fullWidth
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  InputLabelProps={{
                    style: {
                      color: "#A68E5D",
                    },
                  }}
                  InputProps={{
                    style: {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      borderColor: "#A68E5D",
                      borderRadius: "5px",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&:hover fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#A68E5D",
                      },
                    },
                    "& .MuiInputLabel-outlined.Mui-focused": {
                      color: "#A68E5D",
                    },
                    "& input:-webkit-autofill": {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      boxShadow: "0 0 0 1000px #444 inset",
                      transition: "background-color 5000s ease-in-out 0s",
                    },
                  }}
                />
              </Grid>
            </Grid>

            <TextField
              label="Adresse e-mail"
              variant="outlined"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputLabelProps={{
                style: {
                  color: "#A68E5D",
                },
              }}
              InputProps={{
                style: {
                  backgroundColor: "#444",
                  color: "#A68E5D",
                  borderColor: "#A68E5D",
                  borderRadius: "5px",
                },
              }}
              sx={{
                mb: 2,
                mt: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#A68E5D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#A68E5D",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#A68E5D",
                  },
                },
                "& .MuiInputLabel-outlined.Mui-focused": {
                  color: "#A68E5D",
                },
                "& input:-webkit-autofill": {
                  backgroundColor: "#444",
                  color: "#A68E5D",
                  boxShadow: "0 0 0 1000px #444 inset",
                  transition: "background-color 5000s ease-in-out 0s",
                },
              }}
            />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  select
                  label="Pays"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  onOpen={() => {
                    console.log('Opening pays dropdown...');
                    setIsDropdownOpen(true);
                  }}
                  onClose={() => {
                    console.log('Closing pays dropdown...');
                    setIsDropdownOpen(false);
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  error={!!error}
                  helperText={error || "Sélectionnez votre pays"}
                  disabled={status === 'loading'}
                  InputLabelProps={{
                    style: {
                      color: "#A68E5D",
                    },
                  }}
                  InputProps={{
                    style: {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      borderColor: "#A68E5D",
                      borderRadius: "5px",
                    },
                  }}
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&:hover fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#A68E5D",
                      },
                    },
                    "& .MuiInputLabel-outlined.Mui-focused": {
                      color: "#A68E5D",
                    },
                  }}
                >
                  {status === 'loading' ? (
                    <MenuItem disabled>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={20} sx={{ color: '#A68E5D' }} />
                        <Typography>Chargement des pays...</Typography>
                      </Box>
                    </MenuItem>
                  ) : status === 'failed' ? (
                    <MenuItem disabled>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <Typography color="error">{error || "Erreur de chargement"}</Typography>
                        <Button 
                          size="small" 
                          onClick={handleRetry}
                          sx={{ 
                            color: '#A68E5D',
                            '&:hover': {
                              backgroundColor: 'rgba(166, 142, 93, 0.1)',
                            },
                          }}
                        >
                          Réessayer
                        </Button>
                      </Box>
                    </MenuItem>
                  ) : pays && pays.length > 0 ? (
                    pays.filter(country => country.image && country.image.length > 0 && country.image[0]?.path).map((country) => (
                      <MenuItem 
                        key={country._id} 
                        value={country.dbId}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          '&:hover': {
                            backgroundColor: 'rgba(166, 142, 93, 0.1)',
                          },
                        }}
                      >
                        {country?.image?.[0]?.path && (
                          <img
                            src={country.image[0].path}
                            width="22"
                            height="15"
                            style={{ marginRight: "10px" }}
                            alt={country.nom}
                            onError={(e) => {
                              console.warn('Failed to load country flag:', country.nom);
                              e.target.style.display = 'none';
                            }}
                          />
                        )}
                        {country.nom}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>
                      <Typography>Aucun pays disponible</Typography>
                    </MenuItem>
                  )}
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Numéro de téléphone"
                  variant="outlined"
                  fullWidth
                  // required
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  InputLabelProps={{
                    style: {
                      color: "#A68E5D",
                    },
                  }}
                  InputProps={{
                    style: {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      borderColor: "#A68E5D",
                      borderRadius: "5px",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&:hover fieldset": {
                        borderColor: "#A68E5D",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#A68E5D",
                      },
                    },
                    "& .MuiInputLabel-outlined.Mui-focused": {
                      color: "#A68E5D",
                    },
                    "& input:-webkit-autofill": {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      boxShadow: "0 0 0 1000px #444 inset",
                      transition: "background-color 5000s ease-in-out 0s",
                    },
                  }}
                />
              </Grid>
            </Grid>

            <TextField
              label="Adresse"
              variant="outlined"
              fullWidth
              required
              value={adresse}
              onChange={(e) => setAdresse(e.target.value)}
              InputLabelProps={{
                style: {
                  color: "#A68E5D",
                },
              }}
              InputProps={{
                style: {
                  backgroundColor: "#444",
                  color: "#A68E5D",
                  borderColor: "#A68E5D",
                  borderRadius: "5px",
                },
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#A68E5D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#A68E5D",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#A68E5D",
                  },
                },
                "& .MuiInputLabel-outlined.Mui-focused": {
                  color: "#A68E5D",
                },
                "& input:-webkit-autofill": {
                  backgroundColor: "#444",
                  color: "#A68E5D",
                  boxShadow: "0 0 0 1000px #444 inset",
                  transition: "background-color 5000s ease-in-out 0s",
                },
              }}
            />

            <FormControl fullWidth variant="outlined">
              <TextField
                label="Mot de passe"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputLabelProps={{
                  style: {
                    color: "#A68E5D",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: {
                    backgroundColor: "#444",
                    color: "#A68E5D",
                    borderColor: "#A68E5D",
                    borderRadius: "5px",
                  },
                }}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#A68E5D",
                    },
                    "&:hover fieldset": {
                      borderColor: "#A68E5D",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#A68E5D",
                    },
                  },
                  "& .MuiInputLabel-outlined.Mui-focused": {
                    color: "#A68E5D",
                    "& input:-webkit-autofill": {
                      backgroundColor: "#444",
                      color: "#A68E5D",
                      boxShadow: "0 0 0 1000px #444 inset",
                      transition: "background-color 5000s ease-in-out 0s",
                    },
                  },
                }}
              />
            </FormControl>
          </FormControl>

          <Button
            onClick={handleRegister}
            sx={{
              backgroundColor: '#444',
              color: 'white',
              mt: 2,
              padding: '10px',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: '#A68E5D',
              },
            }}
          >
            S'inscrire
          </Button>
          {/* Success/Error Message */}
{message && (
  <Typography
    sx={{
      mt: 2,
      color: messageType === "success" ? "green" : "red",
      fontSize: "1rem",
      fontWeight: "bold",
    }}
  >
    {message}
  </Typography>
)}

        </DialogContent>
      </Dialog>
      <ToastContainer />
    </Box >
  );
};

export default SignUpModal;
